export default __webpack_public_path__ + "static/media/vomsis.ec5dd935.svg";